import Model from './BaseModel'

export default class Permission extends Model {
    resourceName() {
        return 'permissions'
    }

    fields() {
        return ['id', 'name', 'guard_name']
    }
}
